import React, { createContext, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

const AwaitingDialogContext = createContext(null);

export const AwaitingDialogContextProvider = ({ children }) => {
  const [dialogNode, setDialogNode] = useState(null);

  const openConfirmation = node => {
    setDialogNode(node);
  };

  const closeConfirmation = () => {

    setDialogNode(null);
  };

  const confirm = () => {
    setDialogNode(null);
  };

  const value = useMemo(() => {
    return {
      openConfirmation,
      closeConfirmation,
      confirm,
    };
  }, []);

  return (
    <AwaitingDialogContext.Provider value={value}>
      {children}
      {dialogNode}
    </AwaitingDialogContext.Provider>
  );
};

AwaitingDialogContextProvider.propTypes = {
  children: PropTypes.node
};

export const useAwaitingDialogContext = () => {
  return useContext(AwaitingDialogContext);
};
